import React from 'react';
import LoaderSVG from './LoaderSVG';
import NoDataFound from './NoDataFound';

const GridView = ({ 
  data = [], 
  loading, 
  renderItem, 
  columns = { sm: 1, md: 2, lg: 3, xl: 4 },
  skeletonCount = 8,
  noDataMessage = "No items found", 
  noDataSubMessage = "Please check back later"
}) => {
  // Loading skeletons
  if (loading) {
    return (
      <div 
        className={`grid grid-cols-1 sm:grid-cols-${columns.sm} md:grid-cols-${columns.md} lg:grid-cols-${columns.lg} xl:grid-cols-${columns.xl} gap-4`}
      >
        {[...Array(skeletonCount)].map((_, i) => (
          <div
            key={i}
            className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 flex justify-center items-center"
            style={{ height: '180px' }}
            aria-label="Loading item"
          >
            <LoaderSVG />
          </div>
        ))}
      </div>
    );
  }

  // Empty state
  if (!data || data.length === 0) {
    return <NoDataFound message={noDataMessage} subMessage={noDataSubMessage} />;
  }

  // Grid display
  return (
    <div 
      className={`grid grid-cols-1 sm:grid-cols-${columns.sm} md:grid-cols-${columns.md} lg:grid-cols-${columns.lg} xl:grid-cols-${columns.xl} gap-4`}
    >
      {data.map((item, index) => (
        <div 
          key={item.id || index} 
          className="bg-white border border-gray-200 rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-200"
        >
          {renderItem(item, index)}
        </div>
      ))}
    </div>
  );
};

export default GridView;
